module.exports = __webpack_public_path__ + "static/media/helpPage-bg.1c1e665a.jpg";